import { type EsitoValidazioneRichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/esitoValidazioneRichiestaDTO.ts';
import { getNetworkErrorMessage } from '@framework/auth/http/errors/getNetworkErrorMessage.ts';
import { Modal, message } from 'antd';
import { AxiosError } from 'axios';
import { type TFunction } from 'i18next';

/**
 * Gestisce gli errori di cardinalità restituendo un messaggio di errore, se presenti.
 */
function handleCardinalityError(data: {
  codice?: string;
  descrizione?: string;
}): boolean {
  if (data?.codice !== '0004' || typeof data?.descrizione !== 'string') {
    return false;
  }
  try {
    const parsed = JSON.parse(data.descrizione);
    if (parsed && Array.isArray(parsed)) {
      message.error(parsed.join(', '));
      return true;
    }
  } catch (jsonError) {
    // biome-ignore format: <tbd>
    console.error(`[SubmissionSendButton] Error parsing cardinality violations`, {error: jsonError});
  }
  return false;
}

/**
 * Gestisce gli errori di validazione restituendo un modal con la lista degli errori, se presenti.
 */
function handleValidationErrors(
  esito: EsitoValidazioneRichiestaDTO | undefined,
  t: TFunction,
): boolean {
  if (!esito?.errors?.length) return false;
  Modal.error({
    title: t('form.validazione-agid-errore-titolo', 'Errori di validazione'),
    content: (
      <ul>
        {esito.errors.map(err => (
          <li key={err.error}>{err.error}</li>
        ))}
      </ul>
    ),
  });
  return true;
}

/**
 * Gestisce gli errori durante l'invio della richiesta,
 * mostrando un messaggio di errore generico o specifico a seconda del tipo di errore.
 */
export function handleSendError(e: unknown, t: TFunction): void {
  // biome-ignore format: <tbd>
  console.error(`[SubmissionSendButton] Error while sending submission`, {error: e});

  if (e instanceof AxiosError && e?.status === 400) {
    const response = e.response?.data as EsitoValidazioneRichiestaDTO;
    if (handleValidationErrors(response, t)) return;
    if (handleCardinalityError(e.response?.data)) return;
  }

  // biome-ignore format: <tbd>
  message.error(getNetworkErrorMessage(e, t("form.errore-durante-invio", "Si è verificato un errore durante l'invio")));
}
